import styled from '@emotion/styled';
import { Button, Checkbox, Text } from '@innovationdepartment/proxima-ui';
import ClearIcon from '@mui/icons-material/Clear';
import Plan from './PlanFilter.Container';
import SpendActivityFilter from './SpendActivityFilter.Container';

const FiltersViewWrapper = styled.div`
  display: flex;
  flex: 1;
  align-items: center;
  justify-content: flex-end;
`;

type FiltersViewProps = {
  onFilterPlan: (selectedPlans: string[]) => void;
  onFilterSpend: (selectedItems: string[]) => void;
  clearFilters: () => void;
  hasSelectedFilters: boolean;
  onIncludeLockedBrands: (exclude: boolean) => void;
  includeLockedBrands: boolean;
};

const FiltersView = ({
  onFilterPlan,
  onFilterSpend,
  clearFilters,
  onIncludeLockedBrands,
  includeLockedBrands,
  hasSelectedFilters
}: FiltersViewProps) => (
  <>
    <Checkbox
      checked={includeLockedBrands}
      onChange={onIncludeLockedBrands}
      label="Include locked brands"
    />
    <FiltersViewWrapper>
      <Text variant="body1"> Filters: </Text>
      <SpendActivityFilter onFilterSpend={onFilterSpend} />
      <Plan onFilterPlan={onFilterPlan} />
      {!!hasSelectedFilters && (
        <Button
          startIcon={<ClearIcon style={{ fill: 'black' }} />}
          variant="outlined"
          label="Clear filters"
          color="secondary"
          overrideColors={{ backgroundColor: 'transparent' }}
          onClick={clearFilters}
        />
      )}
    </FiltersViewWrapper>
  </>
);

export default FiltersView;
